const StoriesHeader = () => {
    return (
        <div className="stories-section-header">
            <h3 className="stories-tittle">{'Stories'}</h3>
        </div>
    );
};
export default StoriesHeader;
